import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthRoutingModule } from "./auth-routing.module";
import { RecoveryComponent } from "./recovery/recovery.component";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { AuthComponent } from "./auth.component";
import { SharedModule } from "src/app/shared/shared.module";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { LoginAlianzaComponent } from "./login-alianza/login-alianza.component";
import { RegisterAlianzaComponent } from "./register-alianza/register-alianza.component";
import { RecoveryAlianzaComponent } from "./recovery-alianza/recovery-alianza.component";
import { NgSelectizeModule } from "ng-selectize";
import { NgxCaptchaModule } from "ngx-captcha";
@NgModule({
  declarations: [
    RecoveryComponent,
    LoginComponent,
    RegisterComponent,
    AuthComponent,
    LoginAlianzaComponent,
    RegisterAlianzaComponent,
    RecoveryAlianzaComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSmartModalModule.forRoot(),
    NgSelectizeModule,
    NgxCaptchaModule,
  ],
  exports: [AuthComponent],
})
export class AuthModule {}
